<agpr-take-over-panel
    [id]="id"
    [header]="'VisibilityIntelligence.querySetup.header'"
    [ariaLabel]="'VisibilityIntelligence.querySetup.header'"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    [hideSlideOverlay]="hideSlideOverlay"
    [responsiveWidth]="true"
    [maxPanelWidth]="1150"
    [minPanelWidth]="1150"
    (visibleChange)="close($event)"
>

    <div class="agpr-viQuerySetup">
        @if (isCreateQuestionPage) {
            <!-- Generate Question Page -->
            <div
                class="agpr-viQuerySetup-createQuestion"
                [agprLoading]="isGenerating"
            >
                <div class="agpr-viQuerySetup-createQuestion-info">
                    <span
                        class="agpr-viQuerySetup-createQuestion-info-icon fa-kit-duotone fa-agpr-ai-visibility"
                        aria-hidden="true"
                    ></span>
                    <h3 class="agpr-viQuerySetup-createQuestion-info-title">
                        {{ 'VisibilityIntelligence.querySetup.questions.createYourQuestions' | localize }}
                    </h3>
                    <p class="agpr-viQuerySetup-createQuestion-info-subtitle">
                        {{ 'VisibilityIntelligence.querySetup.questions.label' | localize }}
                    </p>
                    <p class="agpr-viQuerySetup-createQuestion-info-message">
                        {{ 'VisibilityIntelligence.querySetup.questions.info1' | localize }}
                    </p>
                    <p class="agpr-viQuerySetup-createQuestion-info-message">
                        {{ 'VisibilityIntelligence.querySetup.questions.info2' | localize }}
                    </p>
                </div>
                <div class="agpr-viQuerySetup-createQuestion-questionsContainer">
                    <h3 class="agpr-viQuerySetup-createQuestion-questions-title">
                        {{ 'VisibilityIntelligence.querySetup.questions.getStarted' | localize }}
                    </h3>
                    <div class="agpr-viQuerySetup-createQuestion-questions">
                        @for (dimension of dimensions; track $index) {
                            <div class="agpr-viQuerySetup-createQuestion-question">
                                <div class="agpr-viQuerySetup-createQuestion-question-label">{{ dimension.label | localize }}</div>
                                <div class="agpr-viQuerySetup-createQuestion-question-count">
                                    <agpr-number-input
                                        [id]="id + '_dimension_' + dimension.key + '_count'"
                                        [min]="0"
                                        [max]="questionCountLimit"
                                        [integerOnly]="true"
                                        [ngModel]="dimension.count"
                                        (ngModelChange)="dimension.count = $event; onQuestionCountChange()"
                                    ></agpr-number-input>
                                </div>
                            </div>
                        }
                    </div>
                    <agpr-button
                        [id]="id + '_createQuestion_generate'"
                        class="agpr-viQuerySetup-createQuestion-generate"
                        [style]="buttonTypes.primary"
                        label="VisibilityIntelligence.querySetup.generate"
                        (click)="generateQuestions()"
                        [disabled]="!canGenerate || isGenerating"
                    ></agpr-button>
                </div>
                <agpr-button
                    [id]="id + '_createQuestion_manually'"
                    class="agpr-viQuerySetup-createQuestion-manually"
                    [style]="buttonTypes.tertiary"
                    [label]="'VisibilityIntelligence.querySetup.createQuestionsManually'"
                    (click)="openManuallyAddQuestionPanel()"
                ></agpr-button>
            </div>
        } @else {
            <!-- Review Question Page -->
            <div class="agpr-viQuerySetup-reviewQuestion">
                <div class="agpr-viQuerySetup-reviewQuestion-lhp">
                    <div class="agpr-viQuerySetup-reviewQuestion-header">
                        <h3 class="agpr-viQuerySetup-reviewQuestion-heading">
                            {{ 'VisibilityIntelligence.querySetup.reviewQuestion.heading' | localize }}
                        </h3>
                        <p class="agpr-viQuerySetup-reviewQuestion-subHeading">
                            {{ 'VisibilityIntelligence.querySetup.reviewQuestion.subHeading' | localize }}
                        </p>
                    </div>
                    <div class="agpr-viQuerySetup-reviewQuestion-totalCount">
                        {{ 'VisibilityIntelligence.querySetup.reviewQuestion.totalQuestions' | localize: { count: questions?.length ?? 0 } }}
                    </div>
                    <div class="agpr-viQuerySetup-reviewQuestion-toolbar">
                        <agpr-button
                            [id]="id + '_toggleExpansion'"
                            [style]="buttonTypes.textToggle"
                            [label]="isExpanded ? 'VisibilityIntelligence.querySetup.reviewQuestion.actions.collapseAll' : 'VisibilityIntelligence.querySetup.reviewQuestion.actions.expandAll'"
                            (click)="toggleExpansion()"
                        ></agpr-button>
                        <agpr-kebab-menu
                            [id]="id + '_add'"
                            class="agpr-viQuerySetup-reviewQuestion-kebab"
                            panelClass="agpr-viQuerySetup-reviewQuestion-kebabPanel"
                            [style]="buttonTypes.icon"
                            icon="fa-regular fa-duotone fa-square-plus"
                            [options]="actions"
                            [panelPositionX]="panelPosition.right"
                            textAlignment="left"
                        ></agpr-kebab-menu>
                    </div>
                    <agpr-scroll-panel #reviewQuestionScrollPanel>
                        <ul class="agpr-viQuerySetup-reviewQuestion-groups">
                            @for (card of dimensionCards; track card.dimension) {
                                <li>
                                    <agpr-vi-dimension-card
                                        [id]="id + '_dimensionCard_' + card.dimension"
                                        [card]="card"
                                        [selectedQuestion]="selectedQuestion"
                                        (questionSelected)="selectQuestion($event)"
                                        (questionDeleted)="deleteQuestion($event)"
                                    ></agpr-vi-dimension-card>
                                </li>
                            }
                        </ul>
                    </agpr-scroll-panel>
                </div>
                <div class="agpr-viQuerySetup-reviewQuestion-rhp">
                    <h4 class="agpr-viQuerySetup-questionDetails-heading">
                        {{ 'VisibilityIntelligence.querySetup.reviewQuestion.questionDetails.questionsInfomation' | localize }}
                    </h4>
                    <agpr-scroll-panel>
                        <div class="agpr-viQuerySetup-questionDetails">
                            @if (selectedQuestion) {
                                <agpr-panel [header]="'VisibilityIntelligence.querySetup.reviewQuestion.questionDetails' | localize">
                                    <agpr-vi-question-details
                                        [id]="id + '_questionDetails'"
                                        [(ngModel)]="selectedQuestion"
                                        (ngModelChange)="questionChanged()"
                                    ></agpr-vi-question-details>
                                </agpr-panel>
                                @if (selectedQuestion.rationale) {
                                    <agpr-panel [header]="'VisibilityIntelligence.querySetup.reviewQuestion.questionDetails.rational' | localize">
                                        <p class="agpr-viQuerySetup-questionDetails-rationale">
                                            {{ selectedQuestion.rationale }}
                                        </p>
                                    </agpr-panel>
                                }
                            } @else {
                                <agpr-message
                                    class="agpr-viQuerySetup-questionDetails-noContent"
                                    [severity]="messageSeverities.noContent"
                                >
                                    {{ 'VisibilityIntelligence.querySetup.reviewQuestion.questionDetails.noSelection' | localize }}
                                </agpr-message>
                            }
                        </div>
                        <div class="agpr-viQuerySetup-questionDetails-activeQuestionSummary">
                            <agpr-vi-active-question-summary
                                [id]="id + '_activeQuestionSummary'"
                                [questionsCount]="questions.length"
                            ></agpr-vi-active-question-summary>
                        </div>
                    </agpr-scroll-panel>
                </div>
            </div>
        }
    </div>

    <ng-template #takeOverFooterLeft>
        <agpr-button
            [id]="id + '_cancel'"
            [style]="buttonTypes.secondary"
            label="cancel"
            (click)="cancel()"
        ></agpr-button>
    </ng-template>
    <ng-template #takeOverFooterRight>
        @if (!isCreateQuestionPage) {
            <agpr-button
                [id]="id + '_done'"
                [style]="buttonTypes.primary"
                label="done"
                (click)="done()"
            ></agpr-button>
        }
    </ng-template>
</agpr-take-over-panel>
